import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";

const slug = (l) => l.toLowerCase().replace(/ /g, "-");
const cls = ({ isActive }) => `flex flex-1 flex-col items-center gap-1 py-2.5 text-[11px] font-medium ${isActive ? "text-primary" : "text-muted-foreground"}`;

const Dot = ({ n, testid }) => (n > 0 ? <span data-testid={testid} className="absolute -right-2 -top-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-600 px-1 text-[9px] font-bold text-white">{n}</span> : null);

export const MobileNav = ({ items, badges = {} }) => {
  const [open, setOpen] = useState(false);
  const main = items.slice(0, 4);
  const more = items.slice(4);
  return (
    <>
      <nav className="no-print fixed inset-x-0 bottom-0 z-40 flex items-stretch justify-around border-t bg-card/95 px-1 pb-[env(safe-area-inset-bottom)] backdrop-blur-xl lg:hidden">
        {main.map((n) => (
          <NavLink key={n.to} to={n.to} end={n.end} data-testid={`mobile-nav-${slug(n.label)}`} className={cls}>
            <span className="relative"><n.icon className="h-5 w-5" /><Dot n={badges[n.to]} testid={`mobile-badge-${slug(n.label)}`} /></span> {n.label}
          </NavLink>
        ))}
        {more.length > 0 && (
          <button data-testid="mobile-nav-more" onClick={() => setOpen(true)} className="flex flex-1 flex-col items-center gap-1 py-2.5 text-[11px] font-medium text-muted-foreground">
            <span className="relative"><Menu className="h-5 w-5" /><Dot n={more.reduce((a, n) => a + (badges[n.to] || 0), 0)} testid="mobile-badge-more" /></span> More
          </button>
        )}
      </nav>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="bottom" className="rounded-t-3xl pb-10">
          <SheetHeader><SheetTitle className="font-display">More</SheetTitle></SheetHeader>
          <div className="mt-4 grid grid-cols-3 gap-3">
            {more.map((n) => (
              <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)} data-testid={`mobile-more-${slug(n.label)}`}
                className={({ isActive }) => `flex flex-col items-center gap-2 rounded-2xl border p-4 text-xs font-semibold ${isActive ? "border-primary text-primary" : "text-muted-foreground"}`}>
                <span className="relative"><n.icon className="h-6 w-6" /><Dot n={badges[n.to]} testid={`mobile-more-badge-${slug(n.label)}`} /></span> {n.label}
              </NavLink>
            ))}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};
